import classnames from "classnames";
import React from "react";
import { Hyperlink, LazyloadImage } from "src/components";
import { translate } from "src/services/translation.service";
import { media } from "src/theme";
import styled from "styled-components";

import { LinkButton, RichTextBlock, Slice } from "../components";
import { ISliceBanners } from "../types";

const TextBlock = styled(RichTextBlock)`
  text-align: center;
`;

const Image = styled.img`
  display: block;
  margin: auto;
  max-width: 100%;
  height: auto;
`;

const LinkImage = styled(Hyperlink)`
  display: inline-block;
`;

interface IColumns {
  columnCount?: number;
  columnCountMobile?: number;
}

const Columns = styled.div<IColumns>`
  ${({ columnCountMobile }: IColumns): string | undefined =>
    columnCountMobile
      ? `
      display: grid;
      grid-template-columns: repeat(${columnCountMobile}, 1fr);
      grid-gap: 10px;
    `
      : undefined};

  ${media.mobile} {
    ${({ columnCount }: IColumns): string | undefined =>
      columnCount
        ? `
        display: grid;
        grid-template-columns: repeat(${columnCount}, 1fr);
        grid-gap: 10px;
      `
        : undefined};
  }
`;

export const Banners = ({
  slice_type,
  primary,
  items,
}: ISliceBanners): JSX.Element | null => {
  const {
    class_name: className,
    background_color: backgroundColor,
    background_image: backgroundImage,
    rich_text_top: richTextTop,
    rich_text_bottom: richTextBottom,
    column_count: columnCount,
    column_count_mobile: columnCountMobile,
    background_as_image: backgroundAsImage,
  } = primary;

  return (
    <Slice
      className={classnames("slice-banners", className)}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      backgroundAsImage={backgroundAsImage}
      noGutter
    >
      <TextBlock className="banner-text-intro" render={richTextTop} />
      <Columns
        className="columns"
        columnCount={columnCount ?? 1}
        columnCountMobile={columnCountMobile ?? 1}
      >
        {items.map(
          (
            {
              banner_image,
              banner_href,
              banner_rich_text_top,
              banner_rich_text_bottom,
              banner_link_url,
              banner_link_label,
            },
            i: number
          ) => (
            <div className="banner-item" key={i}>
              <RichTextBlock
                className="banner-item-text-top"
                render={banner_rich_text_top}
              />

              <LinkImage className="banner-item-image" to={banner_href}>
                <LazyloadImage height={banner_image.dimensions?.height}>
                  <Image
                    src={banner_image.url}
                    alt={banner_image.alt ?? `banner-${i}`}
                  />
                </LazyloadImage>
              </LinkImage>

              <RichTextBlock
                className="banner-item-text-bottom"
                render={banner_rich_text_bottom}
              />

              <LinkButton to={banner_link_url}>
                {banner_link_label || translate("global.seeMore")}
              </LinkButton>
            </div>
          )
        )}
      </Columns>
      <TextBlock className="banner-text-outro" render={richTextBottom} />
    </Slice>
  );
};
